<script setup lang="ts">
const { accountBreadcrumbs } = useStaticBreadcrumbs();

useBreadcrumbs(accountBreadcrumbs({ type: 'recover' }));
</script>

<!--CUSTOM IDS-104: changed styling-->
<template>
    <div class="justift-left container flex w-full">
        <div class="w-128">
            <AccountResetPassword />
        </div>
    </div>
</template>
